export default "__VITE_ASSET__95186cc4__"